import { Table } from '@mantine/core';
import { formatToCurrency } from '../../../util/formatting';
import type { ProductSaleDto } from '../../../util/types/ReceiptViewDto';
import { KeyedRow } from '../../../components/KeyedRow';

interface TableRowProps {
	saleItems: ProductSaleDto;
}

export function ReceiptTableRow({ saleItems: element }: TableRowProps) {
	return (
		<>
			<KeyedRow key={element.name}>
				<Table.Td>{element.skuid}</Table.Td>
				<Table.Td>{element.name}</Table.Td>
				<Table.Td>{element.soldCount}</Table.Td>
				<Table.Td>{formatToCurrency(element.profitPerItem)}</Table.Td>
				<Table.Td>{formatToCurrency(element.price)}</Table.Td>
				<Table.Td>{formatToCurrency(element.netSales)}</Table.Td>
				<Table.Td>{formatToCurrency(element.vat)}</Table.Td>
				<Table.Td>{formatToCurrency(element.discount)}</Table.Td>
			</KeyedRow>
		</>
	);
}
